import { render } from "./ProdutoCompleto.vue?vue&type=template&id=28b9eb91&scoped=true"
import script from "./ProdutoCompleto.vue?vue&type=script&lang=js"
export * from "./ProdutoCompleto.vue?vue&type=script&lang=js"

import "./ProdutoCompleto.vue?vue&type=style&index=0&id=28b9eb91&lang=scss"
import "./ProdutoCompleto.vue?vue&type=style&index=1&id=28b9eb91&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b9eb91"]])

export default __exports__